module.exports = __webpack_public_path__ + "img/personality-assessment.c7738a14.svg";